import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { BookingEducationProgramDTO } from '@core/apis/booking-education/booking-education.dto';
import { BookingRehabilitationProgramDTO } from '@core/apis/booking-rehabilitation/booking-rehabilitation.dto';
import { BookingServiceDTO } from '@core/apis/booking-service/booking-service.dto';
import { EducationProgramDTO } from '@core/apis/education/education.dto';
import { RehabilitationProgramDTO } from '@core/apis/rehabilitation/rehabilitation.dto';
import { ServiceDTO } from '@core/apis/service/service.dto';
import { BookingStorageEnum } from '@core/enums/booking.enum';
import { TranslocoModule } from '@jsverse/transloco';
declare let bootstrap: any;

@Component({
  selector: 'app-order-detail-modal',
  imports: [TranslocoModule, CommonModule],
  templateUrl: './order-detail-modal.component.html',
  styleUrl: './order-detail-modal.component.scss',
})
export class OrderDetailModalComponent {
  @Input() public program!: EducationProgramDTO | RehabilitationProgramDTO | ServiceDTO;
  @Input() public orderType!: BookingStorageEnum;
  @Input() public order!: BookingEducationProgramDTO | BookingRehabilitationProgramDTO | BookingServiceDTO;

  private modalInstance!: any;

  constructor() {}

  public openModal() {
    const modalElement = document.getElementById('basketModal');
    if (modalElement) {
      this.modalInstance = new bootstrap.Modal(modalElement, {
        backdrop: 'static',
        keyboard: false,
      });
      this.modalInstance.show();
    }
  }

  public closeModal() {
    if (this.modalInstance) {
      this.modalInstance.hide();
    }
  }
}
